import {ApplicationDataState} from "./types";
import {createSlice} from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit';

export const initialState: ApplicationDataState = {
    szrExchangePlaceGeoPointJson: '{}'
};

const slice = createSlice({
    name: 'applicationForm',
    initialState,
    reducers: {
        setStartDate(state: ApplicationDataState, action: PayloadAction<[Date]>) {
            state.startDate = action.payload;
        },
        setFinishDate(state: ApplicationDataState, action: PayloadAction<[Date]>) {
            state.finishDate = action.payload;
        },
        setPolygonJson(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['polygonJson']>) {
            state.polygonJson = action.payload;
        },
        setJobVid(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['jobVid']>) {
            state.jobVid = action.payload;
        },
        setSzr(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['szr']>) {
            state.szr = action.payload;
        },
        setCustomerName(state: ApplicationDataState, action: PayloadAction<string | undefined>) {
            state.customerName = action.payload;
        },
        setCustomerRekv(state: ApplicationDataState, action: PayloadAction<string>) {
            state.customerRekv = action.payload;
        },
        setCustomerInn(state: ApplicationDataState, action: PayloadAction<string>) {
            state.customerInn = action.payload;
        },
        setCustomerTlf(state: ApplicationDataState, action: PayloadAction<string>) {
            state.customerTlf = action.payload;
        },
        setCustomerEmail(state: ApplicationDataState, action: PayloadAction<string>) {
            state.customerEmail = action.payload;
        },
        setPrice(state: ApplicationDataState, action: PayloadAction<number>) {
            state.price = action.payload;
        },
        setSzrExchangePlace(state: ApplicationDataState, action: PayloadAction<string>) {
            state.szrExchangePlace = action.payload;
        },
        setSzrExchangePlaceGeoPointJson(state: ApplicationDataState, action: PayloadAction<string>) {
            state.szrExchangePlaceGeoPointJson = action.payload;
        },
        setSzrExchangeTime(state: ApplicationDataState, action: PayloadAction<[Date]>) {
            state.szrExchangeTime = action.payload;
        },
        setKeyWord(state: ApplicationDataState, action: PayloadAction<string>) {
            state.keyWord = action.payload;
        },
        setComment(state: ApplicationDataState, action: PayloadAction<string>) {
            state.comment = action.payload;
        },
    },
});

export const {actions, reducer} = slice;